// "Pick up where you left off" — last-visited PDP card (CRO "Showing User last visited PDP in
// next session", V2 — approved, rolled out to 100% of mobile web).
//
// Files (same name as the tracking file last-visited-pdp-tracking.js):
//   assets/last-visited-pdp.js · assets/last-visited-pdp.css — loaded from snippets/core-assets.liquid.
//
// The CRO team's variant code, unchanged except the places marked [Theme rollout]: mobile web
// only, the card's stylesheet is fetched only when a card is shown, and the card is shown only
// on pages with #collectionmodalcontainer (the SearchTap grid — Shop All), right before it;
// never at the end of the page (it landed below the footer). Never for the product being viewed.
// Every page still records the PDP visit and watches add-to-cart, so the card stays accurate.
// Tracking: assets/last-visited-pdp-tracking.js (watches for [data-dk-lvp]).
//
// QA: add ?lvp_wait=5 to any URL to make the card wait 5 seconds instead of 30 minutes in that
// browser tab (?lvp_wait=off to undo). Shoppers are unaffected.
(function () {
  'use strict';

  // [Theme rollout] Mobile web only (below the theme's md breakpoint, 768px), as tested.
  if (!window.matchMedia || !window.matchMedia('(max-width: 767px)').matches) return;
  var LVP_SCRIPT = document.currentScript;
  var LVP_CSS_URL = LVP_SCRIPT ? LVP_SCRIPT.getAttribute('data-lvp-css') : null;

  var CONFIG = {
    STORAGE_KEY: 'dk_last_viewed_product',    // localStorage key for the candidate product
    DISMISS_KEY: 'dk_widget_dismissed',       // localStorage key when user hits the X
    TAB_ID_KEY: 'dk_tab_id',                  // sessionStorage key: unique id for THIS tab only
    LEFT_PDP_TIMEOUT_SECONDS: 1800,              // wait this long after leaving a PDP before showing —
                                               // same rule everywhere: same tab, new tab, minimized, etc.
    EXPIRE_HOURS: 72,                         // candidate expires after this long
    SCHEMA_VERSION: 4,                        // bump this whenever the saved candidate's shape changes,
                                               // so old-format leftovers from a previous script version
                                               // get discarded instead of rendering with blank/0 data
    // Where to insert the widget. Update the selector if your container's
    // id/casing differs. [Theme rollout] Not found → no card on that page.
    INSERT_BEFORE_SELECTORS: [
      '#CollectionModalContainer',
      '#collectionModalContainer',
      '#collectionmodalcontainer'
    ],
    CURRENCY_SYMBOL: '₹'
  };

  // [Theme rollout] QA only — test the card without waiting 30 minutes:
  //   open any page with ?lvp_wait=5   → wait is 5 seconds in this browser tab
  //   open any page with ?lvp_wait=off → back to the normal wait (CONFIG.LEFT_PDP_TIMEOUT_SECONDS)
  var QA_WAIT_KEY = 'dk_lvp_qa_wait_seconds';
  function getWaitSeconds() {
    try {
      var param = new URLSearchParams(window.location.search).get('lvp_wait');
      if (param === 'off' || param === '0') sessionStorage.removeItem(QA_WAIT_KEY);
      else if (param && /^\d{1,4}$/.test(param)) sessionStorage.setItem(QA_WAIT_KEY, param);
      var qa = sessionStorage.getItem(QA_WAIT_KEY);
      if (qa) return parseInt(qa, 10);
    } catch (e) {}
    return CONFIG.LEFT_PDP_TIMEOUT_SECONDS;
  }

  function getTabContext() {
    try {
      var existing = sessionStorage.getItem(CONFIG.TAB_ID_KEY);
      var isNewTab = !existing;
      var tabId = existing || ('t_' + Date.now() + '_' + Math.random().toString(36).slice(2, 8));
      if (isNewTab) sessionStorage.setItem(CONFIG.TAB_ID_KEY, tabId);
      return { tabId: tabId, isNewTab: isNewTab };
    } catch (e) {
      return { tabId: null, isNewTab: true };
    }
  }

  /* ---------------------------------------------------------------------
     STORAGE HELPERS
     --------------------------------------------------------------------- */
  function saveCandidate(product, tabId) {
    try {
      product.savedAt = Date.now(); // when the PDP was viewed (fallback reference)
      product.tabId = tabId;        // the specific tab it was viewed in
      product.schemaVersion = CONFIG.SCHEMA_VERSION;
      localStorage.setItem(CONFIG.STORAGE_KEY, JSON.stringify(product));
    } catch (e) {}
  }

  // Stamps the exact moment the user navigates away from the PDP — this is
  // the real "left PDP" timestamp the 1-minute wait is measured from.
  function markLeftPDP(productId) {
    try {
      var raw = localStorage.getItem(CONFIG.STORAGE_KEY);
      if (!raw) return;
      var data = JSON.parse(raw);
      if (data.productId === productId) {
        data.leftAt = Date.now();
        localStorage.setItem(CONFIG.STORAGE_KEY, JSON.stringify(data));
      }
    } catch (e) {}
  }

  function attachLeavePDPTracking(productId) {
    // [Theme rollout] pagehide only — it fires on every navigation away (incl. mobile Safari), and a
    // beforeunload listener would make the page ineligible for the back/forward cache in Firefox.
    window.addEventListener('pagehide', function () { markLeftPDP(productId); });
  }

  function clearCandidate() {
    try { localStorage.removeItem(CONFIG.STORAGE_KEY); } catch (e) {}
  }

  function getCandidate() {
    try {
      var raw = localStorage.getItem(CONFIG.STORAGE_KEY);
      if (!raw) return null;
      var data = JSON.parse(raw);
      // Discard anything saved by an older, incompatible version of this
      // script — rendering it as-is would show blank/₹0 data instead.
      if (data.schemaVersion !== CONFIG.SCHEMA_VERSION) { clearCandidate(); return null; }
      var ageHours = (Date.now() - (data.savedAt || 0)) / 36e5;
      if (ageHours > CONFIG.EXPIRE_HOURS) { clearCandidate(); return null; }
      return data;
    } catch (e) { return null; }
  }

  function isDismissed(productId, tabId) {
    try {
      var raw = localStorage.getItem(CONFIG.DISMISS_KEY);
      if (!raw) return false;
      var d = JSON.parse(raw);
      // Only counts as dismissed within the exact same tab it was dismissed
      // in; a new tab gets a clean slate even for the same product.
      return d && d.productId === productId && d.tabId === tabId;
    } catch (e) { return false; }
  }

  function setDismissed(productId, tabId) {
    try {
      localStorage.setItem(CONFIG.DISMISS_KEY, JSON.stringify({ productId: productId, tabId: tabId, at: Date.now() }));
    } catch (e) {}
  }

  /* ---------------------------------------------------------------------
     PDP DETECTION + PRODUCT EXTRACTION
     --------------------------------------------------------------------- */
  function isProductPage() {
    return /\/products\//.test(window.location.pathname);
  }

  // Reads the same hidden JSON pattern used in your listing "variant-selector"
  // component: <variant-selector data-product-id="..."><div data-variant-data>{...}</div>
  function readVariantSelectorJSON(scope) {
    scope = scope || document;
    var selector = scope.querySelector('variant-selector[data-product-id]');
    if (!selector) return null;
    var dataEl = selector.querySelector('[data-variant-data]');
    if (!dataEl) return null;
    try {
      var json = JSON.parse(dataEl.textContent.trim());
      json.productId = selector.getAttribute('data-product-id');
      return json;
    } catch (e) { return null; }
  }

  function pickSelectedVariant(json) {
    if (!json || !json.variants || !json.variants.length) return null;
    // Try to find the variant matching whichever option button is pressed.
    // Match on the ATTRIBUTES both the listing page and the real PDP share
    // (data-option-value + aria-pressed) rather than a specific class name —
    // the listing page uses .variant-option, the PDP uses
    // .main-pdp-variants__pill, so a class-based selector only works on one.
    var pressedBtn = document.querySelector('[data-option-value][aria-pressed="true"]');
    if (pressedBtn) {
      var val = pressedBtn.getAttribute('data-option-value');
      for (var i = 0; i < json.variants.length; i++) {
        if (json.variants[i].options && json.variants[i].options.indexOf(val) !== -1) {
          return json.variants[i];
        }
      }
    }
    // fall back to first available variant
    for (var j = 0; j < json.variants.length; j++) {
      if (json.variants[j].available) return json.variants[j];
    }
    return json.variants[0];
  }

  // The size/shade label to show in the widget. Prefer the pressed button's
  // own visible text (e.g. "80g") since the PDP's variant JSON here has no
  // "title" field at all — only "options".
  function getSelectedVariantLabel(variant) {
    var pressedBtn = document.querySelector('[data-option-value][aria-pressed="true"]');
    if (pressedBtn && pressedBtn.textContent.trim()) return pressedBtn.textContent.trim();
    if (variant.title) return variant.title;
    if (variant.options && variant.options[0]) return variant.options[0];
    return '';
  }


  function getVariantImage(variant) {
    if (variant.image) return normalizeImage(variant.image);

    try {
      var stickyMapEl = document.querySelector('[data-sticky-variant-images]');
      if (stickyMapEl) {
        var map = JSON.parse(stickyMapEl.textContent.trim());
        if (map[variant.id]) return normalizeImage(map[variant.id]);
      }
    } catch (e) {}

    if (variant.featured_media_id) {
      var slideImg = document.querySelector('[data-media-id="' + variant.featured_media_id + '"] img');
      if (slideImg && slideImg.src) return slideImg.src;
    }

    var mainImg = document.querySelector('.main-pdp__gallery-img, [data-pdp-slide] img, .product-card__image');
    if (mainImg && mainImg.src) return mainImg.src;

    var og = document.querySelector('meta[property="og:image"]');
    if (og && og.content) return normalizeImage(og.content);

    return '';
  }

  function normalizeImage(url) {
    if (!url) return '';
    if (url.indexOf('//') === 0) return 'https:' + url;
    return url;
  }

  function getProductTitle() {
    var og = document.querySelector('meta[property="og:title"]');
    if (og && og.content) return og.content.trim();
    var h1 = document.querySelector('h1');
    if (h1 && h1.textContent.trim()) return h1.textContent.trim();
    return document.title.split('|')[0].trim();
  }

  // The PDP's own price block reflects any auto-applied sitewide discount
  // (e.g. a "FLAT15" code) that the raw variant JSON does NOT encode — on
  // this PDP, variant.price and variant.compare_at_price are literally
  // identical (595/595) yet the page visibly shows ₹506 with "Save ₹89
  // (15%)". Read that live-rendered truth straight off the DOM instead of
  // trusting the flat JSON numbers.
  function getLivePdpPriceInfo() {
    try {
      var priceEl = document.querySelector('[data-pdp-price-integer]');
      var compareEl = document.querySelector('[data-pdp-compare-price-integer]');
      var pctEl = document.querySelector('[data-pdp-save-pct]');
      var current = priceEl ? parseFloat(priceEl.textContent.replace(/[^\d.]/g, '')) : null;
      var compare = compareEl ? parseFloat(compareEl.textContent.replace(/[^\d.]/g, '')) : null;
      var pct = pctEl ? parseFloat(pctEl.getAttribute('data-pdp-save-pct')) : null;
      return {
        current: (current && current > 0) ? current : null,
        compare: (compare && compare > 0) ? compare : null,
        pct: (pct && pct > 0) ? pct : null
      };
    } catch (e) { return { current: null, compare: null, pct: null }; }
  }

  // For color/shade variants (identified by data-is-color="true" on the
  // option buttons, e.g. the tinted-sunscreen shade picker), builds a map
  // of optionValue -> swatch color, read straight off each button's own
  // inline background-color. Returns {} for plain size-style products,
  // which naturally falls back to the existing text-pill rendering.
  function buildColorSwatchMap() {
    var map = {};
    try {
      var btns = document.querySelectorAll('[data-option-value][data-is-color="true"]');
      for (var i = 0; i < btns.length; i++) {
        var btn = btns[i];
        var val = btn.getAttribute('data-option-value');
        if (!val || map[val]) continue;
        var fillEl = btn.querySelector('[style*="background-color"]') || btn;
        var bg = window.getComputedStyle(fillEl).backgroundColor;
        if (bg && bg !== 'rgba(0, 0, 0, 0)' && bg !== 'transparent') map[val] = bg;
      }
    } catch (e) {}
    return map;
  }

  function buildVariantSummary(rawVariant, isSelected, livePrice, colorMap) {
    var basePrice = (rawVariant.price || 0) / 100; // acts as the true MRP/original price here
    var jsonComparePrice = (rawVariant.compare_at_price || rawVariant.price || 0) / 100;

    var price = basePrice;
    var comparePrice = jsonComparePrice > basePrice ? jsonComparePrice : basePrice;
    var discountPct = jsonComparePrice > basePrice ? Math.round((1 - basePrice / jsonComparePrice) * 100) : 0;

    if (isSelected && livePrice.current) {
      // This is the variant the PDP is actually showing right now — trust
      // its live-rendered price exactly.
      price = livePrice.current;
      comparePrice = livePrice.compare || basePrice;
      discountPct = livePrice.pct || (comparePrice > price ? Math.round((1 - price / comparePrice) * 100) : 0);
    } else if (livePrice.pct) {
      // Any other variant: assume the same sitewide % discount applies
      // uniformly and estimate its live price the same way.
      comparePrice = basePrice;
      price = Math.round(basePrice * (1 - livePrice.pct / 100));
      discountPct = livePrice.pct;
    }

    var label = (rawVariant.options && rawVariant.options[0]) || rawVariant.title || '';
    return {
      id: rawVariant.id,
      label: label,
      price: price,
      comparePrice: comparePrice,
      discountPct: discountPct,
      image: getVariantImage(rawVariant),
      available: rawVariant.available !== false,
      color: (colorMap && colorMap[label]) || null
    };
  }

  function extractCurrentProduct() {
    var json = readVariantSelectorJSON();
    if (!json || !json.variants || !json.variants.length) return null;

    var selected = pickSelectedVariant(json);
    var selectedId = selected ? selected.id : json.variants[0].id;
    var livePrice = getLivePdpPriceInfo();
    var colorMap = buildColorSwatchMap();

    var variants = [];
    for (var i = 0; i < json.variants.length; i++) {
      variants.push(buildVariantSummary(json.variants[i], json.variants[i].id === selectedId, livePrice, colorMap));
    }

    // Prefer the pressed button's own visible text for the initial label,
    // same reasoning as before — the PDP's variant JSON may have no "title".
    if (selected) {
      for (var j = 0; j < variants.length; j++) {
        if (variants[j].id === selected.id) {
          variants[j].label = getSelectedVariantLabel(selected) || variants[j].label;
          break;
        }
      }
    }

    return {
      productId: json.productId,
      title: getProductTitle(),
      url: window.location.pathname,
      variants: variants,
      selectedVariantId: selectedId
    };
  }

  /* ---------------------------------------------------------------------
     WATCH FOR A SUCCESSFUL ADD-TO-CART ON THE PDP
     --------------------------------------------------------------------- */
  /* ---------------------------------------------------------------------
     ENSURE THE CART DRAWER OPENS
     Your theme already opens [data-cart-panel] on a normal add-to-cart, so
     this only acts as a fallback: if our widget triggered the add (flagged
     via window.__dkLvpAwaitingCartOpen) and the drawer still isn't visible
     a moment later, we click the real header cart icon ([data-cart-trigger])
     ourselves — the exact same element a user would click.
     --------------------------------------------------------------------- */
  function isCartDrawerVisible() {
    try {
      var panel = document.querySelector('[data-cart-panel]');
      if (!panel) return false;
      var rect = panel.getBoundingClientRect();
      if (rect.width === 0 || rect.height === 0) return false;
      if (rect.right <= 0 || rect.left >= window.innerWidth) return false; // translated off-screen
      var style = window.getComputedStyle(panel);
      if (style.display === 'none' || style.visibility === 'hidden' || parseFloat(style.opacity || '1') === 0) return false;
      return true;
    } catch (e) { return false; }
  }

  function ensureCartDrawerOpen() {
    try {
      if (isCartDrawerVisible()) return;
      var trigger = document.querySelector('[data-cart-trigger]');
      if (trigger) trigger.click();
    } catch (e) {}
  }

  function onAddToCartSucceeded() {
    clearCandidate();
    if (window.__dkLvpAwaitingCartOpen) {
      window.__dkLvpAwaitingCartOpen = false;
      setTimeout(ensureCartDrawerOpen, 400); // give the theme's own logic a chance first
    }
  }

  function watchAddToCart() {
    // 1) Intercept fetch() calls used by AJAX add-to-cart
    if (window.fetch && !window.__dkLvpFetchPatched) {
      window.__dkLvpFetchPatched = true;
      var origFetch = window.fetch;
      window.fetch = function () {
        var urlArg = arguments[0];
        var url = (typeof urlArg === 'string') ? urlArg : (urlArg && urlArg.url) || '';
        var promise = origFetch.apply(this, arguments);
        if (url.indexOf('/cart/add') !== -1) {
          promise.then(function (res) {
            if (res && res.ok) onAddToCartSucceeded();
          }).catch(function () {});
        }
        return promise;
      };
    }

    // 2) Intercept XHR-based add-to-cart
    if (window.XMLHttpRequest && !window.__dkLvpXhrPatched) {
      window.__dkLvpXhrPatched = true;
      var origOpen = XMLHttpRequest.prototype.open;
      XMLHttpRequest.prototype.open = function (method, url) {
        this.__dkLvpIsCartAdd = typeof url === 'string' && url.indexOf('/cart/add') !== -1;
        if (this.__dkLvpIsCartAdd) {
          this.addEventListener('load', function () {
            if (this.status >= 200 && this.status < 300) onAddToCartSucceeded();
          });
        }
        return origOpen.apply(this, arguments);
      };
    }

    // 3) Fallback: plain <form action="/cart/add"> submit (non-AJAX theme forms)
    document.addEventListener('submit', function (e) {
      var form = e.target;
      if (form && form.getAttribute && form.getAttribute('action') === '/cart/add') {
        onAddToCartSucceeded();
      }
    }, true);
  }

  /* ---------------------------------------------------------------------
     WIDGET RENDER
     --------------------------------------------------------------------- */
  // Reuses the SAME <product-form><form data-product-form>...</form>
  // </product-form> shape your theme already uses on the PDP, and fires a
  // genuine .click() on its submit button — so whatever listener your theme
  // already has wired up (the custom element, a delegated submit handler,
  // etc.) runs exactly as if the real "Add to cart" button was tapped,
  // including opening the minicart drawer if that's what it normally does.
  function submitAddToCart(productId, variantId, onDone) {
    try {
      var wrapEl = document.createElement('product-form');
      wrapEl.setAttribute('data-product-id', productId);
      wrapEl.style.display = 'none';

      var formEl = document.createElement('form');
      formEl.action = '/cart/add';
      formEl.method = 'post';
      formEl.setAttribute('data-product-form', '');

      var idInput = document.createElement('input');
      idInput.type = 'hidden';
      idInput.name = 'id';
      idInput.value = variantId;
      formEl.appendChild(idInput);

      var qtyInput = document.createElement('input');
      qtyInput.type = 'hidden';
      qtyInput.name = 'quantity';
      qtyInput.value = '1';
      formEl.appendChild(qtyInput);

      var submitBtn = document.createElement('button');
      submitBtn.type = 'submit';
      submitBtn.setAttribute('data-product-card-atc', '');
      formEl.appendChild(submitBtn);

      wrapEl.appendChild(formEl);
      document.body.appendChild(wrapEl);

      // Give the custom element a tick to upgrade/wire up its listeners,
      // then click its button exactly like a real tap would.
      setTimeout(function () {
        window.__dkLvpAwaitingCartOpen = true; // seen by onAddToCartSucceeded()
        submitBtn.click();
        setTimeout(function () {
          if (wrapEl.parentNode) wrapEl.parentNode.removeChild(wrapEl);
          if (onDone) onDone();
        }, 1200);
      }, 0);
    } catch (e) {
      if (onDone) onDone();
    }
  }

  function buildWidget(product, tabId) {
    var wrap = document.createElement('div');
    wrap.className = 'dk-lvp-wrap';
    wrap.setAttribute('data-dk-lvp', '');

    var variants = product.variants || [];
    var activeId = product.selectedVariantId || (variants[0] && variants[0].id);

    function getVariant(id) {
      for (var i = 0; i < variants.length; i++) {
        // Loose/string comparison on purpose: the id coming from a clicked
        // pill's data-attribute is always a string, while variant.id (and
        // the initial selectedVariantId) come straight from the JSON as
        // numbers — a strict === here silently matches nothing.
        if (String(variants[i].id) === String(id)) return variants[i];
      }
      return variants[0];
    }

    // Only show a pill row when there's actually a choice to make; a
    // single-variant product just shows its one label as a plain badge.
    // Color/shade products (data-is-color="true" on the real PDP) render
    // as round swatches instead, matching the real PDP's own pattern of a
    // swatch row plus a separate shade-name line below it.
    var hasColor = variants.some(function (v) { return !!v.color; });
    var pillsHTML = '';
    if (variants.length > 1 && hasColor) {
      var activeVariantForName = getVariant(activeId) || variants[0];
      pillsHTML = '<div class="dk-lvp-swatches">' + variants.map(function (v) {
        var cls = 'dk-lvp-variant-pill dk-lvp-swatch'
          + (v.id === activeId ? ' is-active' : '')
          + (!v.available ? ' is-unavailable' : '');
        var style = 'background-color:' + (v.color || '#ccc') + ';';
        return '<button type="button" class="' + cls + '" data-variant-id="' + v.id + '" style="' + style + '"'
          + ' title="' + escapeHTML(v.label) + '" aria-label="' + escapeHTML(v.label) + '"'
          + (!v.available ? ' disabled' : '') + '></button>';
      }).join('') + '</div>' +
      '<p class="dk-lvp-shade-name">' + escapeHTML(activeVariantForName.label) + '</p>';
    } else if (variants.length > 1) {
      pillsHTML = '<div class="dk-lvp-variants">' + variants.map(function (v) {
        var cls = 'dk-lvp-variant-pill'
          + (v.id === activeId ? ' is-active' : '')
          + (!v.available ? ' is-unavailable' : '');
        return '<button type="button" class="' + cls + '" data-variant-id="' + v.id + '"'
          + (!v.available ? ' disabled' : '') + '>' + escapeHTML(v.label) + '</button>';
      }).join('') + '</div>';
    } else if (variants.length === 1 && variants[0].label) {
      pillsHTML = '<span class="dk-lvp-variant">' + escapeHTML(variants[0].label) + '</span><br>';
    }

    function priceHTMLFor(v) {
      var html = '<span class="dk-lvp-price-current">' + CONFIG.CURRENCY_SYMBOL + Math.round(v.price) + '</span>';
      if (v.comparePrice > v.price) {
        html += '<span class="dk-lvp-price-compare">' + CONFIG.CURRENCY_SYMBOL + Math.round(v.comparePrice) + '</span>';
        html += '<span class="dk-lvp-price-off">(' + v.discountPct + '% off)</span>';
      }
      return html;
    }

    var initialVariant = getVariant(activeId) || { price: 0, comparePrice: 0, discountPct: 0, image: product.variants && product.variants[0] && product.variants[0].image, available: true };

    wrap.innerHTML =
      '<div class="dk-lvp-header">' +
        '<div class="dk-lvp-icon">' +
          '<svg xmlns="http://www.w3.org/2000/svg" width="20" height="19" viewBox="0 0 20 19" fill="none">' +
          '<path d="M9.85129 10.1269L13.5789 12.9227C13.8535 13.1286 14.2428 13.073 14.4487 12.7984C14.6547 12.5238 14.5991 12.1346 14.3245 11.9286L10.8733 9.31618V4.03534C10.8733 3.69208 10.5953 3.41406 10.252 3.41406C9.90876 3.41406 9.63074 3.69208 9.63074 4.03534V9.62681C9.63074 9.83308 9.71709 10.0188 9.85129 10.1269Z" fill="white"/>' +
          '<path d="M10.5626 0C6.01517 0 2.13189 3.2822 1.37393 7.76594L1.13785 7.41492C0.945565 7.13006 0.559132 7.05489 0.274277 7.24718C-0.0105774 7.43946 -0.0857516 7.82589 0.106533 8.11075L1.34908 9.97457C1.45128 10.1299 1.61778 10.2315 1.80261 10.251H1.86474C2.02938 10.2504 2.18687 10.1846 2.30274 10.0678L3.85593 8.51458C4.09854 8.27197 4.09854 7.87808 3.85593 7.63547C3.61332 7.39286 3.21943 7.39286 2.97682 7.63547L2.59163 8.02377C3.30703 3.62079 7.45622 0.631837 11.8589 1.34724C16.2616 2.06263 19.2511 6.21151 18.5357 10.6145C17.9005 14.5242 14.5235 17.3963 10.5626 17.3957C8.06445 17.4411 5.70174 16.2625 4.23491 14.2396C4.03579 13.9601 3.6478 13.8945 3.36823 14.0936C3.08865 14.2927 3.02311 14.6807 3.22223 14.9603C4.92079 17.3125 7.66186 18.6858 10.5626 18.6383C15.7095 18.6383 19.8817 14.4661 19.8817 9.31913C19.8817 4.17217 15.7095 0 10.5626 0Z" fill="white"/>' +
          '</svg>' +
        '</div>' +
        '<p class="dk-lvp-title">Pick up where you left off</p>' +
        '<p class="dk-lvp-sub">You were viewing this product earlier</p>' +
        '<button type="button" class="dk-lvp-close" aria-label="Close"><svg xmlns="http://www.w3.org/2000/svg" width="7" height="7" viewBox="0 0 7 7" fill="none"><path d="M0.400024 0.400391L6.40002 6.40039" stroke="#ACACAC" stroke-width="0.8" stroke-linecap="round"/><path d="M6.40002 0.400391L0.400024 6.40039" stroke="#ACACAC" stroke-width="0.8" stroke-linecap="round"/></svg></button>' +
      '</div>' +
      '<div class="dk-lvp-body">' +
        (initialVariant.image ? '<img class="dk-lvp-img" src="' + initialVariant.image + '" alt="">' : '') +
        '<div class="dk-lvp-info">' +
          '<p class="dk-lvp-name">' + escapeHTML(product.title) + '</p>' +
          pillsHTML +
          '<div class="dk-lvp-price-parent">' +
            '<div class="dk-lvp-price">' + priceHTMLFor(initialVariant) + '</div>' +
            '<button type="button" class="dk-lvp-cta">ADD TO CART</button>' +
          '</div>' +
        '</div>' +
      '</div>';

    var imgEl = wrap.querySelector('.dk-lvp-img');
    var priceEl = wrap.querySelector('.dk-lvp-price');
    var ctaBtn = wrap.querySelector('.dk-lvp-cta');
    var shadeNameEl = wrap.querySelector('.dk-lvp-shade-name');

    function setCtaAvailability(v) {
      if (!v.available) {
        ctaBtn.disabled = true;
        ctaBtn.textContent = 'SOLD OUT';
      } else {
        ctaBtn.disabled = false;
        ctaBtn.textContent = 'ADD TO CART';
      }
    }
    setCtaAvailability(initialVariant);

    // Switching a size/shade pill updates price, image and the CTA — no
    // page reload, no re-fetching anything; all the data was captured
    // up front when the PDP was originally viewed.
    var pillButtons = wrap.querySelectorAll('.dk-lvp-variant-pill');
    for (var p = 0; p < pillButtons.length; p++) {
      pillButtons[p].addEventListener('click', function () {
        if (this.disabled) return;
        var v = getVariant(this.getAttribute('data-variant-id'));
        if (!v) return;
        activeId = v.id;

        var current = wrap.querySelector('.dk-lvp-variant-pill.is-active');
        if (current) current.classList.remove('is-active');
        this.classList.add('is-active');

        priceEl.innerHTML = priceHTMLFor(v);
        if (imgEl && v.image) imgEl.src = v.image;
        if (shadeNameEl) shadeNameEl.textContent = v.label;
        setCtaAvailability(v);
      });
    }

    wrap.querySelector('.dk-lvp-close').addEventListener('click', function () {
      setDismissed(product.productId, tabId);
      wrap.remove();
    });

    imgEl && imgEl.addEventListener('click', function () {
      window.location.href = product.url;
    });
    wrap.querySelector('.dk-lvp-name').addEventListener('click', function () {
      window.location.href = product.url;
    });

    ctaBtn.addEventListener('click', function (e) {
      var btn = e.currentTarget;
      var v = getVariant(activeId);
      if (!v || !v.available) return;
      btn.disabled = true;
      btn.textContent = 'ADDING...';
      // Our global fetch/XHR watcher (watchAddToCart, active on every page)
      // will independently clear the candidate the moment it sees the
      // resulting /cart/add call succeed, however the theme performs it.
      submitAddToCart(product.productId, v.id, function () {
        btn.textContent = 'ADDED ✓';
        setTimeout(function () { wrap.remove(); }, 1200);
      });
    });

    return wrap;
  }

  function escapeHTML(str) {
    var div = document.createElement('div');
    div.textContent = str || '';
    return div.innerHTML;
  }

  function findInsertTarget() {
    for (var i = 0; i < CONFIG.INSERT_BEFORE_SELECTORS.length; i++) {
      var el = document.querySelector(CONFIG.INSERT_BEFORE_SELECTORS[i]);
      if (el) return el;
    }
    return null;
  }

  // [Theme rollout] The card's stylesheet (assets/last-visited-pdp.css) is fetched only when a
  // card is shown, so visits without one download nothing extra.
  var lvpCssState = null; // null | 'loading' | 'ready'
  var lvpCssQueue = [];
  function withCardStyles(done) {
    if (!LVP_CSS_URL || lvpCssState === 'ready') { done(); return; }
    lvpCssQueue.push(done);
    if (lvpCssState === 'loading') return;
    lvpCssState = 'loading';
    var link = document.createElement('link');
    link.rel = 'stylesheet';
    link.href = LVP_CSS_URL;
    var finish = function () {
      if (lvpCssState === 'ready') return;
      lvpCssState = 'ready';
      var queued = lvpCssQueue; lvpCssQueue = [];
      for (var i = 0; i < queued.length; i++) queued[i]();
    };
    link.onload = finish;
    link.onerror = finish; // never block the card on a failed stylesheet
    setTimeout(finish, 3000);
    document.head.appendChild(link);
  }

  function insertWidget(wrap) {
    withCardStyles(function () {
      if (document.querySelector('[data-dk-lvp]')) return; // already shown meanwhile
      insertWidgetNow(wrap);
    });
  }

  function insertWidgetNow(wrap) {
    var target = findInsertTarget();
    if (target && target.parentNode) {
      target.parentNode.insertBefore(wrap, target);
    }
  }

  function renderWidgetIfNeeded(currentPDPProduct, tabContext) {
    // [Theme rollout] Shop All only — no SearchTap grid, no card (and no stylesheet fetch).
    if (!findInsertTarget()) return;
    var candidate = getCandidate();
    if (!candidate || !candidate.variants || !candidate.variants.length) return;
    // Don't show the widget for the very product the user is currently viewing
    if (currentPDPProduct && currentPDPProduct.productId === candidate.productId) return;
    if (isDismissed(candidate.productId, tabContext.tabId)) return;
    if (document.querySelector('[data-dk-lvp]')) return; // already rendered

    // Single rule, everywhere: gate purely on real time since the user
    // actually left the PDP — same tab, new tab, minimized, doesn't matter.
    // leftAt is stamped by attachLeavePDPTracking() the moment they
    // navigated away; savedAt (when the PDP was viewed) is the fallback if,
    // for some reason, that never fired.
    var referenceTime = candidate.leftAt || candidate.savedAt || 0;
    var timeoutMs = getWaitSeconds() * 1000; // [Theme rollout] QA switch, else CONFIG.LEFT_PDP_TIMEOUT_SECONDS
    var remaining = timeoutMs - (Date.now() - referenceTime);

    if (remaining <= 0) {
      insertWidget(buildWidget(candidate, tabContext.tabId));
      return;
    }

    // Not time yet — if the user just sits on this page (e.g. shop-all)
    // without navigating again, show it the moment the wait is up.
    setTimeout(function () {
      var stillCandidate = getCandidate();
      if (!stillCandidate || stillCandidate.productId !== candidate.productId) return; // added to cart / replaced meanwhile
      if (isDismissed(stillCandidate.productId, tabContext.tabId)) return;
      if (document.querySelector('[data-dk-lvp]')) return;
      insertWidget(buildWidget(stillCandidate, tabContext.tabId));
    }, remaining);
  }

  /* ---------------------------------------------------------------------
     INIT
     --------------------------------------------------------------------- */
  function init() {
    getWaitSeconds(); // [Theme rollout] remember a ?lvp_wait=… QA switch for this tab, on any page
    var tabContext = getTabContext();   // kept only to scope this tab's dismiss state
    watchAddToCart();                   // active on EVERY page — needed to detect adds
                                         // triggered by the widget's own button too

    var currentProduct = null;
    if (isProductPage()) {
      currentProduct = extractCurrentProduct();
      if (currentProduct) {
        saveCandidate(currentProduct, tabContext.tabId);
        attachLeavePDPTracking(currentProduct.productId); // stamps leftAt on navigation away
      }
    }

    renderWidgetIfNeeded(currentProduct, tabContext);
  }

  if (document.readyState === 'complete' || document.readyState === 'interactive') {
    setTimeout(init, 0);
  } else {
    document.addEventListener('DOMContentLoaded', init);
  }
})();
